export const qaLabelAutodispatcher = {
    addAutodispatcherBtn:'autodispatcher--add-btn',
    autodispatcherTitle:'autodispatcher--title',
    autodispatcherRow: 'autodispatcher--row',
    autodispatcherTab:'tab-item--autoDispatchers',
    autoDispatcherModal:{
        // Also for Autodispatcher modal in edit mode
        policyNameInput:'autodispatcher--new-autodispatcher-modal--policy-name-input',
        underwayCheckbox:'autodispatcher--new-autodispatcher-modal--underway-checkbox',
        singleOverflowDispatchCheckbox:'autodispatcher--new-autodispatcher-modal--single-overflow-checkbox',
        ruleTab:'autodispatcher--new-autodispatcher-modal--rule-row', // not being used
        editBtn:'autodispatcher--new-autodispatcher-modal--rule-edit-btn',
        trashBtn:'autodispatcher--new-autodispatcher-modal--rule-trash-btn',
        addNewRuleBtn: 'autodispatcher--new-autodispatcher-modal--add-new-rule-btn',
        saveBtn:'autodispatcher--new-autodispatcher-modal--save-btn',
        cancelBtn:'autodispatcher--new-autodispatcher-modal--cancel-btn',
        title: 'autodispatcher--new-autodispatcher-modal--title',
        idLabel: 'autodispatcher--new-autodispatcher-modal--id-label',
        pillTitle: 'autodispatcher--new-autodispatcher-modal-rules-pill-title',
        deleteBtn: 'autodispatcher--new-autodispatcher-modal--delete-btn',
        deleteAutodispatcherModal:{
            deleteBtn: 'autodispatcher--autodispatcher-modal--delete-autodispatcher-modal--delete-btn',
            title: 'autodispatcher--autodispatcher-modal--delete-autodispatcher-modal--title',
            message: 'autodispatcher--autodispatcher-modal--delete-autodispatcher-modal--message',
        }
    },
    ruleModal:{
        title: 'autodispatcher--new-rule-modal--title',
        dispatchChoiceDropdown: 'autodispatcher--new-rule-modal--dispatch-dropdown',
        includeSubteamsCheckbox:  'autodispatcher--new-rule-modal--include-subteams--checkbox',
        teamsDropdown: 'autodispatcher--new-rule-modal--teams-dropdown',
        conditionsDropdown: 'autodispatcher--new-rule-modal--condition-dropdown',
        saveRuleBtn: 'autodispatcher--new-rule-modal--save-btn',
        addConditionBtn:'autodispatcher--new-rule-modal--add-condition-btn',
        conditionValueInput:'autodispatcher--new-rule-modal--condition-value-input',
        conditionDropdown:'autodispatcher--new-rule-modal--condition-dropdown' ,
        conditionRow:'autodispatcher--new-rule-modal--condition-row-div',
        unitOptions:'autodispatcher--new-rule-modal--condition-unit-option',
        removeConditionBtn: 'autodispatcher--new-rule-modal--remove-condition-btn'
    }
};
